import React, { useEffect, useState } from "react";
import api, { formatErr } from "../../lib/api";

const cardStyle = {
  padding: 12, background: "var(--pf-surface)",
  border: "1px solid var(--pf-border)", borderRadius: 8,
};
const labelStyle = {
  fontSize: 11, fontWeight: 700, color: "var(--pf-muted)",
  textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 8,
};
const inputStyle = {
  width: "100%", padding: "6px 8px", fontSize: 12, borderRadius: 5,
  border: "1px solid var(--pf-border)", background: "var(--pf-surface-2)",
  color: "var(--pf-fg)",
};
const btnStyle = {
  padding: "8px 14px", fontSize: 12, fontWeight: 700,
  background: "var(--pf-ember)", color: "#fff", border: 0,
  borderRadius: 5, cursor: "pointer",
};

export default function PipingSpecsPanel({ projectId }) {
  const [classes, setClasses] = useState([]);
  const [filter, setFilter] = useState("");
  const [autoForm, setAutoForm] = useState({
    operating_T_C: 150, operating_P_barg: 15, fluid: "crude oil", sour: false,
  });
  const [autoResult, setAutoResult] = useState(null);
  const [validateForm, setValidateForm] = useState({
    class_id: "1A1", operating_T_C: 50, operating_P_barg: 5, fluid: "fuel gas", sour: false,
  });
  const [validateResult, setValidateResult] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/piping-specs/classes")
      .then(({ data }) => setClasses(data))
      .catch((e) => setErr(formatErr(e?.response?.data?.detail) || String(e)));
  }, []);

  const runAutoSelect = async () => {
    setErr(""); setAutoResult(null);
    try {
      const { data } = await api.post("/piping-specs/auto-select", autoForm);
      setAutoResult(data);
    } catch (e) {
      setErr(formatErr(e?.response?.data?.detail) || String(e));
    }
  };
  const runValidate = async () => {
    setErr(""); setValidateResult(null);
    try {
      const { data } = await api.post("/piping-specs/validate", validateForm);
      setValidateResult(data);
    } catch (e) {
      setErr(formatErr(e?.response?.data?.detail) || String(e));
    }
  };

  const filtered = (Array.isArray(classes) ? classes : []).filter((c) => {
    const f = String(filter || "").toLowerCase();
    if (!f || !c) return !f;
    return String(c.id || "").toLowerCase().includes(f)
        || String(c.name || "").toLowerCase().includes(f)
        || String(c.material || "").toLowerCase().includes(f);
  });

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
      {err && <div style={{ gridColumn: "1/-1", padding: 8, background: "rgba(239,68,68,.1)", color: "#FF8888", borderRadius: 5, fontSize: 12 }}>{err}</div>}

      {/* Auto-select tool */}
      <div style={cardStyle} data-testid="piping-autoselect-card">
        <div style={labelStyle}>Auto-Select Pipe Class</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          <input style={inputStyle} type="number" placeholder="Operating T (°C)"
            data-testid="ps-auto-T"
            value={autoForm.operating_T_C} onChange={(e) => setAutoForm({ ...autoForm, operating_T_C: +e.target.value })} />
          <input style={inputStyle} type="number" placeholder="Operating P (barg)"
            data-testid="ps-auto-P"
            value={autoForm.operating_P_barg} onChange={(e) => setAutoForm({ ...autoForm, operating_P_barg: +e.target.value })} />
          <input style={{ ...inputStyle, gridColumn: "span 2" }} placeholder="Fluid description"
            data-testid="ps-auto-fluid"
            value={autoForm.fluid} onChange={(e) => setAutoForm({ ...autoForm, fluid: e.target.value })} />
          <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 6 }}>
            <input type="checkbox" data-testid="ps-auto-sour"
              checked={autoForm.sour} onChange={(e) => setAutoForm({ ...autoForm, sour: e.target.checked })} />
            Sour service (NACE)
          </label>
          <button style={btnStyle} data-testid="ps-auto-run" onClick={runAutoSelect}>Auto-Select</button>
        </div>
        {autoResult && <ResultBox title="Recommendation" data={autoResult} />}
      </div>

      {/* Validator tool */}
      <div style={cardStyle} data-testid="piping-validate-card">
        <div style={labelStyle}>Validate Pipe Class</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          <select style={inputStyle} data-testid="ps-val-class"
            value={validateForm.class_id}
            onChange={(e) => setValidateForm({ ...validateForm, class_id: e.target.value })}>
            {classes.map((c) => <option key={c.id} value={c.id}>{c.id} — {c.name.slice(0, 30)}</option>)}
          </select>
          <input style={inputStyle} placeholder="Fluid" data-testid="ps-val-fluid"
            value={validateForm.fluid} onChange={(e) => setValidateForm({ ...validateForm, fluid: e.target.value })} />
          <input style={inputStyle} type="number" placeholder="Operating T (°C)" data-testid="ps-val-T"
            value={validateForm.operating_T_C} onChange={(e) => setValidateForm({ ...validateForm, operating_T_C: +e.target.value })} />
          <input style={inputStyle} type="number" placeholder="Operating P (barg)" data-testid="ps-val-P"
            value={validateForm.operating_P_barg} onChange={(e) => setValidateForm({ ...validateForm, operating_P_barg: +e.target.value })} />
          <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 6, gridColumn: "span 2" }}>
            <input type="checkbox" data-testid="ps-val-sour"
              checked={validateForm.sour} onChange={(e) => setValidateForm({ ...validateForm, sour: e.target.checked })} />
            Sour service
          </label>
          <button style={{ ...btnStyle, gridColumn: "span 2" }} data-testid="ps-val-run" onClick={runValidate}>Validate</button>
        </div>
        {validateResult && (
          <div style={{ marginTop: 10 }}>
            <Badge ok={validateResult.ok} />
            {validateResult.errors?.length > 0 && (
              <ul style={{ marginTop: 8, paddingLeft: 18, color: "#FF8888", fontSize: 12 }}>
                {validateResult.errors.map((e, i) => <li key={i}>{e}</li>)}
              </ul>
            )}
            {validateResult.warnings?.length > 0 && (
              <ul style={{ marginTop: 8, paddingLeft: 18, color: "#f59e0b", fontSize: 12 }}>
                {validateResult.warnings.map((w, i) => <li key={i}>{w}</li>)}
              </ul>
            )}
          </div>
        )}
      </div>

      {/* Class library */}
      <div style={{ ...cardStyle, gridColumn: "1/-1" }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 10, gap: 8 }}>
          <div style={{ ...labelStyle, marginBottom: 0, flex: 1 }}>Pipe Class Library — {filtered.length} of {classes.length}</div>
          <input style={{ ...inputStyle, width: 220 }} placeholder="filter id, name, material…"
            data-testid="ps-filter"
            value={filter} onChange={(e) => setFilter(e.target.value)} />
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
            <thead>
              <tr style={{ background: "var(--pf-surface-2)" }}>
                {["ID", "Name", "Material", "Code", "Class", "T-range (°C)", "Max P (barg)", "Schedule", "NACE", "Services"].map((h) =>
                  <th key={h} style={{ padding: 6, textAlign: "left", color: "var(--pf-muted)", textTransform: "uppercase", fontSize: 9 }}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {filtered.map((c) => (
                <tr key={c.id} data-testid={`ps-row-${c.id}`} style={{ borderBottom: "1px solid var(--pf-border)" }}>
                  <td style={{ padding: 6, fontWeight: 700, color: "#F26B1F" }}>{c.id}</td>
                  <td style={{ padding: 6 }}>{c.name}</td>
                  <td style={{ padding: 6, fontFamily: "monospace" }}>{c.material}</td>
                  <td style={{ padding: 6 }}>{c.code}</td>
                  <td style={{ padding: 6 }}>#{c.rating_class}</td>
                  <td style={{ padding: 6 }}>{c.min_T_C} … {c.max_T_C}</td>
                  <td style={{ padding: 6 }}>{c.max_P_barg}</td>
                  <td style={{ padding: 6 }}>{c.schedule}</td>
                  <td style={{ padding: 6 }}>{c.nace_compliant ? "✓" : "—"}</td>
                  <td style={{ padding: 6, fontSize: 10, color: "var(--pf-muted)" }}>
                    {(c.fluid_services || []).slice(0, 2).join(", ")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function ResultBox({ title, data }) {
  return (
    <div style={{ marginTop: 10, padding: 10, background: "var(--pf-surface-2)", border: "1px solid var(--pf-border)", borderRadius: 6 }}>
      <div style={{ ...labelStyle, marginBottom: 6 }}>{title}</div>
      {data.selected ? (
        <>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#F26B1F" }}>
            {data.selected.id} — {data.selected.name}
          </div>
          <div style={{ fontSize: 11, color: "var(--pf-muted)", marginTop: 4 }}>{data.reasoning}</div>
          <div style={{ fontSize: 11, marginTop: 4 }}>
            <strong>Material:</strong> {data.selected.material}<br />
            <strong>Schedule:</strong> {data.selected.schedule} ·
            <strong> Valves:</strong> {data.selected.valve_class}
          </div>
        </>
      ) : (
        <div style={{ color: "#FF8888", fontSize: 12 }}>No class found — {data.reasoning}</div>
      )}
    </div>
  );
}

function Badge({ ok }) {
  const style = {
    display: "inline-block", padding: "3px 10px", fontSize: 11, fontWeight: 700,
    borderRadius: 4, background: ok ? "rgba(34,197,94,.15)" : "rgba(239,68,68,.15)",
    color: ok ? "#22c55e" : "#ef4444", border: `1px solid ${ok ? "#22c55e" : "#ef4444"}55`,
  };
  return <span style={style}>{ok ? "✓ VALID FOR SERVICE" : "✗ NOT SUITABLE"}</span>;
}
